
import React, { Component } from 'react'
import t from 'tcomb-form'
import Form from 'ui/Form'
import Space from 'ui/Space'
import Button from 'ui/Button'

const FormSchema = t.struct({
  email: t.String,
  password: t.String
})

const FormOptions = {
  fields: {
    password: {
      type: 'password',
      attrs: { required: true }
    },
    email: {
      type: 'email',
      attrs: { required: true, autoFocus: true }
    }
  }
}

class LoginForm extends Component {
  render () {
    const values = {
      password: this.props.password,
      email: this.props.email
    }

    return (
      <div className='LoginForm'>
        <Form schema={FormSchema} options={FormOptions} values={values} onSubmit={this.props.onSubmit} onChange={this.props.onChange}>
          <Space value='30' />
          <Button type='submit' extras='fluid' disabled={this.props.isLoading}>
            {this.props.isLoading ? 'logging in...' : 'login'}
          </Button>
        </Form>
      </div>
    )
  }
}

export default LoginForm



// WEBPACK FOOTER //
// ./components/LoginForm.js